import React from 'react'

import Layout from '@components/Common/Layout/Layout'
import Head from '@components/Head'
import PageHero from '@components/Hero/Page/PageHero'
import LoginBlock from '@components/LoginBlock/LoginBlock'

const LoginPage = () => (
  <Layout>
    <Head
      title='Xelex | Login – Machine learning training data made easy'
      description='Xelex – Log in to the industry’s premier platform for creating and managing NLP and machine learning training data.'
    />
    <PageHero title='Login' />
    <LoginBlock />
  </Layout>
)

export default LoginPage
